import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FeatureDiscoveryDialogComponent } from '@core/tellent-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

// TODO: remove?
@Component({
  selector: 'x-feature-discovery-dialog',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TellentFeatureDiscoveryDialogWrapComponent extends DialogWrapComponent<FeatureDiscoveryDialogComponent> {
  public readonly component = FeatureDiscoveryDialogComponent;
  public readonly config = {};
}

export type TellentFeatureDiscoveryDialogWebComponent = TellentWebComponent<
  TellentFeatureDiscoveryDialogWrapComponent,
  'afterClosed' | 'open'
>;
